import { render, staticRenderFns } from "./CalendarioPresenca.vue?vue&type=template&id=b5cf3688&scoped=true"
import script from "./CalendarioPresenca.vue?vue&type=script&lang=js"
export * from "./CalendarioPresenca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5cf3688",
  null
  
)

export default component.exports